import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ScheduledOrderIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Scheduled Order</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.2477 33.8184L31.2841 40.8525H26.0045C26.0045 46.6775 30.7364 51.4093 36.5614 51.4093C38.3364 51.4093 40.0091 50.9525 41.4864 50.1775L44.0545 52.7456C41.8909 54.1161 39.3227 54.9275 36.5614 54.9275C28.7864 54.9275 22.4886 48.6275 22.4886 40.8525H17.2114L24.2477 33.8184ZM36.5623 26.7832C44.335 26.7832 50.6327 33.0786 50.6327 40.8536H55.9077L48.8736 47.8922L41.8373 40.8536H47.1145C47.1145 35.0309 42.3827 30.2991 36.5623 30.2991C34.7827 30.2991 33.0941 30.74 31.6373 31.5309L29.0668 28.965C31.2305 27.5923 33.7986 26.7832 36.5623 26.7832ZM14.7036 5.07501V8.59319H28.7764V5.07501H32.2945V8.59319H34.0536C35.99 8.59319 37.5718 10.175 37.5718 12.1114V24.1886C37.2354 24.1705 36.9014 24.1432 36.5604 24.1432C35.715 24.1432 34.8809 24.2182 34.0536 24.3454V17.3886H9.42638V36.7363H17.5991L15.3446 38.9886L14.0809 40.2545H9.42638C7.47638 40.2545 5.9082 38.6727 5.9082 36.7363L5.92638 12.1114C5.92638 10.175 7.47638 8.59319 9.42638 8.59319H11.1855V5.07501H14.7036Z"
        />
      </g>
    </SvgIcon>
  );
}

export default ScheduledOrderIcon;
